declare global {
  interface Window {
    __GA_CONTEXT__?: {
      measurementId: string;
      organisationId: string;
      organisationDisplayId: string;
      journeyId: string;
      journeyDisplayId: string;
      environmentId: string;
      environmentDimension: string;
    } | null;
    gtag?: (...args: unknown[]) => void;
  }
}

function getContext() {
  return window.__GA_CONTEXT__ ?? null;
}

function isConfigured(): boolean {
  const ctx = getContext();
  return !!ctx?.measurementId;
}

function getEnquiryIdParams(): Record<string, string> {
  const ctx = getContext();
  if (!ctx) return {};
  const params: Record<string, string> = {};
  if (ctx.organisationId) params.organisation_id = ctx.organisationId;
  if (ctx.journeyId) params.journey_id = ctx.journeyId;
  if (ctx.journeyDisplayId) params.journey_display_id = ctx.journeyDisplayId;
  if (ctx.environmentId) params.environment_id = ctx.environmentId;
  if (ctx.environmentDimension) params.environment = ctx.environmentDimension;
  return params;
}

export function initGa4(): void {
  if (!isConfigured()) return;
  const ctx = getContext();
  if (!ctx || !window.gtag) return;
  const params = getEnquiryIdParams();
  if (Object.keys(params).length > 0) {
    const userProperties: Record<string, { value: string }> = {};
    for (const [k, v] of Object.entries(params)) {
      userProperties[k] = { value: v };
    }
    window.gtag("set", "user_properties", userProperties);
  }
}

export function setEnquiryId(enquiryId: string): void {
  if (!isConfigured() || !window.gtag) return;
  window.gtag("set", "user_properties", { enquiry_id: enquiryId });
}

export function trackJourneyView(stepDisplayId: string): void {
  if (!isConfigured() || !window.gtag) return;
  const params = getEnquiryIdParams();
  window.gtag("event", "page_view", {
    page_path: `/${stepDisplayId}`,
    ...params,
  });
}

export function trackJourneyStarted(enquiryId: string): void {
  if (!isConfigured() || !window.gtag) return;
  setEnquiryId(enquiryId);
  const params = getEnquiryIdParams();
  window.gtag("event", "journey_started", {
    enquiry_id: enquiryId,
    ...params,
  });
}

export function trackJourneyStepViewed(stepDisplayId: string): void {
  if (!isConfigured() || !window.gtag) return;
  const params = getEnquiryIdParams();
  window.gtag("event", "journey_step_viewed", {
    step_display_id: stepDisplayId,
    ...params,
  });
}

export function trackJourneyCompleted(): void {
  if (!isConfigured() || !window.gtag) return;
  const params = getEnquiryIdParams();
  window.gtag("event", "journey_completed", params);
}
